"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ShimmeringLoaderBar = require("./ShimmeringLoaderBar.styles");
const ShimmeringLoaderBar = _ref => {
  let {
    height = 37,
    margin = '0 0 0 0',
    width = 100
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_ShimmeringLoaderBar.LoadingElement, {
    height: height,
    margin: margin,
    width: width
  });
};
ShimmeringLoaderBar.propTypes = {
  /**
   * Controls the height of the shimmering bar
   */
  height: _propTypes.default.number,
  /**
   * Controls the margin of the shimmering bar
   */
  margin: _propTypes.default.string,
  /**
   * Controls the width of the shimmering bar
   */
  width: _propTypes.default.number
};
var _default = exports.default = ShimmeringLoaderBar;
ShimmeringLoaderBar.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ShimmeringLoaderBar",
  "props": {
    "height": {
      "defaultValue": {
        "value": "37",
        "computed": false
      },
      "description": "Controls the height of the shimmering bar",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "margin": {
      "defaultValue": {
        "value": "'0 0 0 0'",
        "computed": false
      },
      "description": "Controls the margin of the shimmering bar",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "width": {
      "defaultValue": {
        "value": "100",
        "computed": false
      },
      "description": "Controls the width of the shimmering bar",
      "type": {
        "name": "number"
      },
      "required": false
    }
  }
};